import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import MyInvoiceDetails from "./MyInvoiceDetails";
import EmployeeCostServiceFeeTable from "./EmployeeCostServiceFeeTable";
import EmployeeOvertimeAbsencesTable from "./EmployeeOvertimeAbsencesTable";
import CustomTabs from "components/tabs/customTab";
import AccessButton from "components/button/accessbutton";
import {
  Users,
  FileClock,
  ReceiptText,
} from "lucide-react";

const MyInvoiceTab = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const recordData = useSelector((state) => state.invoice.invoiceDetails?.data);

  const pathParts = location.pathname.split("#").filter(Boolean);
  const lastSegment = pathParts[pathParts.length - 1];
  const [activeTab, setActiveTab] = useState(pathParts.length > 1 ? lastSegment : 'items');

  const invoiceTabs = [
    { 
      value: "items", 
      label: "Items", 
      icon: <ReceiptText />,
      children: 
        <MyInvoiceDetails />,
      type: 0,
    },
    { 
      value: "employee-cost-service-fee", 
      label: "Employee Cost/Service Fee", 
      icon: <Users />,
      children: 
        <EmployeeCostServiceFeeTable />,
      type: 210,
    },
    { 
      value: "overtime-absences-tardiness", 
      label: "Overtime/Absences & Tardiness", 
      icon: <FileClock />,
      children: 
        <EmployeeOvertimeAbsencesTable/>,
      type: 210,
    },
  ];

  const availableTabs = invoiceTabs.filter(tab => (tab.type === 0 || tab.type === recordData?.inv_type_id ));

  const onChange = (value) => {
    setActiveTab(value);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
          <AccessButton
            backLabel="My Invoices"
            withBack={true}
            baseRoute="/console/my-invoices"
          />

          <div className="flex-1 ml-2">
              <CustomTabs
                tabs={availableTabs}
                activeTab={activeTab}
                onChange={onChange}
                height="h-10"
              />
          </div>
      </div>

      <div className="mt-6">
        {availableTabs.find(item => item.value === activeTab)?.children}
      </div>
    </div>
  );
};

export default MyInvoiceTab;
